import { Button, type ButtonProps } from "~/common/components/Button/Button";
import StoreIcon from "@mui/icons-material/Store";
import { useTranslation } from "react-i18next";
import { openModal } from "~/AddToCart/ModalSevice";
import { BuyFromSalesPartnerModal } from "./BuyFromSalesPartnerModal/BuyFromSalesPartnerModal";
import type { ProductData } from "~/models/ProductData";
import { trackBuyFromSalesPartnerButton } from "~/feature/Analytics/ga/ga";
import type { GAPageTypeName } from "~/Search/useSearchPageType";

export const BuyFromSalesPartnerButton = ({
  product,
  onClick: onClickExternal,
  pageType,
  ...props
}: Omit<ButtonProps, "children" | "startIcon"> & { product: ProductData; pageType: GAPageTypeName }) => {
  const { t } = useTranslation();

  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClickExternal?.(e);
    trackBuyFromSalesPartnerButton(product.designation, product.sapMaterialNumber, pageType);
    openModal("buy-from-sales-partner-modal", (close) => (
      <BuyFromSalesPartnerModal onClose={close} product={product} pageType={pageType} />
    ));
  };

  return (
    <Button startIcon={<StoreIcon />} onClick={onClick} fullWidth {...props}>
      {t("addToCart.salesPartner.button")}
    </Button>
  );
};
